import { useState, useMemo, useEffect } from 'react';
import { LeadCard, Lead } from '../components/LeadCardHomeOwner';
import { LeadFilters } from '../components/LeadFiltersHomeowner';
import { LeadStats } from '../components/LeadStats';
import { ListFilter } from 'lucide-react';
import { Container } from 'react-bootstrap';
import { CallAPIPostPromise } from 'Common/commaon';
import { getDecodeId } from 'slices/userProfile/thunk';
import ProjectCardShimmer from 'components/shimmer';
import './homeowner-projects.css';
import { Link } from 'react-router-dom';

interface LeadListPageProps {
  leads: Lead[];
}

export function LeadListPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [assignmentFilter, setAssignmentFilter] = useState('all');
 const [leads,setLeads]=useState([])
 const [loading,setLoading]=useState(false)
  // Filter and search logic
  const filteredLeads = useMemo(() => {
    return leads.filter((lead:any) => {
      // Search filter
      const searchLower = searchQuery.toLowerCase();
      const matchesSearch =
        searchQuery === '' ||
        lead.job_title.toLowerCase().includes(searchLower) ||
        lead.job_description.toLowerCase().includes(searchLower) ||
        lead.city.toLowerCase().includes(searchLower) ||
        lead.state.toLowerCase().includes(searchLower) ||
        lead.address.toLowerCase().includes(searchLower);

      // Status filter
      const matchesStatus = statusFilter === 'all' || lead.job_status === statusFilter;

      // Assignment filter
      let matchesAssignment = true;
      if (assignmentFilter === 'assigned') {
        matchesAssignment = lead.accepted_contractor !== undefined;
      } else if (assignmentFilter === 'unassigned') {
        matchesAssignment = lead.accepted_contractor === undefined && lead.job_status !== 'COMPLETED';
      } else if (assignmentFilter === 'requested') {
        matchesAssignment = lead.requested_contractors > 0;
      }

      return matchesSearch && matchesStatus && matchesAssignment;
    });
  }, [leads, searchQuery, statusFilter, assignmentFilter]);

  // Calculate stats
  const stats = useMemo(() => {
    return {
      totalLeads: leads.length,
      acceptedLeads: leads.filter((l:any) => l.accepted_contractor !== undefined).length,
      requestedLeads: leads.filter((l:any) => l.requested_contractors > 0 && l.job_status === 'REQUESTED').length,
      openLeads: leads.filter((l:any) => l.job_status === 'OPEN').length,
    };
  }, [leads]);

  useEffect(()=>{
    setLoading(true)
CallAPIPostPromise("/jobs/homeownerJobs",{
  homeowner_id:getDecodeId()
}).then((res:any)=>{
setLeads(res)
}).finally(()=>{
  setLoading(false)
})
  },[])
  return (
    <div className='tailwind-prefix page-content homeowner-projects-page'>
                 <Container fluid>
 <div className="homeowner-projects__body bg-gray-50 pb-4">
      {/* Header */}
  

      {/* Main Content */}
      <div className=" ">
        {/* Stats */}
        <LeadStats
          totalLeads={stats.totalLeads}
          acceptedLeads={stats.acceptedLeads}
          requestedLeads={stats.requestedLeads}
          openLeads={stats.openLeads}
        />

        {/* Filters */}
        <LeadFilters
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          assignmentFilter={assignmentFilter}
          onAssignmentFilterChange={setAssignmentFilter}
        />

        {/* Results Header */}
        <div className="homeowner-projects__results flex items-center justify-between mb-4">
          <div className="flex items-center text-gray-600">
            <ListFilter className="w-5 h-5 mr-2" />
            <span>
              Showing {filteredLeads.length} of {leads.length} Projects
            </span>
          </div>
          <Link to="/service-reviews" className="homeowner-project-card__action">My reviews →</Link>
        </div>

        {/* Lead List */}
        {filteredLeads.length > 0 ? (
          <div className="homeowner-projects__grid grid grid-cols-1 lg:grid-cols-2 gap-4">
            {loading?[1,2,3].map(()=>{
              return <ProjectCardShimmer />
            }): filteredLeads.map((lead:any) => (
              <LeadCard key={lead.id} lead={lead} />
            ))}
          </div>
        ) : (
          
            loading?<div className="homeowner-projects__grid grid grid-cols-1 lg:grid-cols-2 gap-4"> {[1,2,3].map(()=>{
              return <ProjectCardShimmer />
            })} </div>:  <div className="homeowner-projects__empty bg-white border border-gray-200 rounded-lg p-12 text-center">   <ListFilter className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No leads found</h3>
            <p className="text-gray-600">
              Try adjusting your filters or search query to find what you're looking for.
            </p> </div>
        
        )}
      </div>
    </div>
    </Container>
    </div>
   
  );
}
